function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { Component } from "react";
import { log } from "@limitless/common/utils/Logging";
export const withLogging = (WrappedComponent, className) => {
  return class Logging extends Component {
    render() {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({
        logger: log.getLogger(className)
      }, this.props));
    }
  };
};